import { ForumTypeEnum } from "./new-forum.model"

export interface ForumType {
    _id: string
    forumTypeName: ForumTypeEnum
}

export interface ForumTypes {
    filterForumTypes: ForumType[]
}

export const forumTypesIconMap = {
    thread: 'folder-bullets',
    topic: 'folder-lines'
}

export const forumTypes: ForumTypes = {
    filterForumTypes: [
        {
            _id: '1',
            forumTypeName: ForumTypeEnum.THREAD,
        },
        {
            _id: '2',
            forumTypeName: ForumTypeEnum.TOPIC,
        },
    ],
}
